module.exports = __webpack_public_path__ + "img/smiley.baff8143.png";